require('./session-timeout-overlay/session-timeout-overlay.scss');
var BaseViews = require('../common/base');
var Countdown = require('../common/count-down.js');
var DateUtils = require('../utils/dates');
var FarmBranding = require('../common/farm-branding.js');
var SessionTimeoutOverlay = BaseViews.LayoutView.extend({
    className: 'fmcy-session-timeout-overlay',
    template: require('./session-timeout-overlay/session-timeout-overlay.html'),
    regions: {
      countdownRegion: '.session-timeout-overlay-countdown-region',
      logoRegion: '.session-timeout-overlay-f-logo-region'
    },
    ui: {
      contentWrapper: '.session-timeout-overlay-content-wrapper'
    },
    events: {
        'click': 'onClick'
    },
    onClick: function() {
        this.trigger('close:clicked');
    },
    _renderCountdown: function () {
      var self = this;
      this._countDown = new Countdown({
        elapse: false,
        startTimestampMs: DateUtils.getNowTimestampMs() + 30000
      });
    this._countDown.on('finished', function () {
        self.trigger('finished');
      })
      this.countdownRegion.show(this._countDown);
    },
    _renderBranding: function () {
      var branding = new FarmBranding({
        style: 'full',
      });
      this.logoRegion.show(branding);
    },
    onRender: function () {
      this._renderBranding();
      this._renderCountdown();
    }
});
module.exports = SessionTimeoutOverlay;



/** WEBPACK FOOTER **
 ** ./assets/js/elo-app/session-timeout-overlay.js
 **/